type Props = { current: number; total: number };

export function ProgressBar({ current, total }: Props) {
  // Clamp to [0, 100] and guard total=0 so width never resolves to NaN/Infinity.
  const progress = total > 0 ? Math.max(0, Math.min(100, (current / total) * 100)) : 0;
  return (
    <>
      <div className="wren-eyebrow mb-4 text-[0.75rem]">
        {current} of {total}
      </div>
      {/* Track uses --color-wren-border (#d0d5dd), not --color-wren-border-subtle
          (#f2f4f7) — the subtle token only has ~1.05:1 contrast against the warm
          surface and is functionally invisible. The border token gives ~1.4:1
          track-vs-page and ~4.8:1 fill-vs-track, which lands the fill above the
          WCAG 1.4.11 3:1 non-text contrast target while keeping the unfilled
          portion visibly present without overwhelming the page. Bumping h-1
          (4px) to h-1.5 (6px) adds visual presence without making the bar chunky.

          Spacing: mb-6 here (24px) keeps the progress + header visually grouped
          as a "metadata + question" pair; the larger gap before the form
          inputs lives on the H2 in SurveyQuestion. */}
      <div
        role="progressbar"
        aria-label="Survey progress"
        aria-valuenow={current}
        aria-valuemin={1}
        aria-valuemax={total}
        className="mb-6 h-1.5 overflow-hidden rounded-full bg-[color:var(--color-wren-border)]"
      >
        {/* Animate `width` instead of `transform: scaleX` — scaleX squishes the
            rounded-full radius on the trailing edge, which made the fill's
            right end read as nearly-square. With width-based animation the
            radius stays a clean stadium shape at both ends. The perf cost is
            negligible at this scale (one transition per question advance). */}
        <div
          className="h-1.5 rounded-full bg-[color:var(--color-wren-green)] transition-[width] duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </>
  );
}
